module.exports = {
    "development": {
        "localhost:8080": {
			url: "http://localhost:7000"
		}
    },
    "production": {
        "kiosk.uat.vdab.partheas.net": {
            url: "https://qpp.uat.vdab.partheas.net"
        },
        "PRODUCTION.TENANT_B": {
            url: "PRODUCTION.TENANT_B_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_C": {
            url: "PRODUCTION.TENANT_C_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_D": {
            url: "PRODUCTION.TENANT_D_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_E": {
            url: "PRODUCTION.TENANT_E_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_F": {
            url: "PRODUCTION.TENANT_F_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_G": {
            url: "PRODUCTION.TENANT_G_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_H": {
            url: "PRODUCTION.TENANT_H_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_I": {
            url: "PRODUCTION.TENANT_I_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_J": {
            url: "PRODUCTION.TENANT_J_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_K": {
            url: "PRODUCTION.TENANT_K_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_L": {
            url: "PRODUCTION.TENANT_L_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_M": {
            url: "PRODUCTION.TENANT_M_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_N": {
            url: "PRODUCTION.TENANT_N_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_O": {
            url: "PRODUCTION.TENANT_O_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_P": {
            url: "PRODUCTION.TENANT_P_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_Q": {
            url: "PRODUCTION.TENANT_Q_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_R": {
            url: "PRODUCTION.TENANT_R_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_S": {
            url: "PRODUCTION.TENANT_S_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_T": {
            url: "PRODUCTION.TENANT_T_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_U": {
            url: "PRODUCTION.TENANT_U_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_V": {
            url: "PRODUCTION.TENANT_V_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_W": {
            url: "PRODUCTION.TENANT_W_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_X": {
            url: "PRODUCTION.TENANT_X_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_Y": {
            url: "PRODUCTION.TENANT_Y_API_REDIRECT_URL"
        },
        "PRODUCTION.TENANT_Z": {
            url: "PRODUCTION.TENANT_Z_API_REDIRECT_URL"
        }
    }
}